var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-block-container" },
    [
      _vm.statusCardsFiltered.length < 3
        ? _c("div", {
            staticStyle: {
              width: "16%",
              float: "left",
              margin: "5px",
              "box-sizing": "border-box",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.statusCardsFiltered, function (card) {
        return _c(
          "div",
          {
            staticClass: "table-block",
            class: { "table-block-small": _vm.statusCardsFiltered.length > 3 },
          },
          [
            _c(
              "div",
              {
                key: card.colorClass,
                staticClass: "table-block-inner dashboardStatusCard",
                class: card.colorClass,
                on: {
                  click: function ($event) {
                    return _vm.filterSendBox(card.changePageValue)
                  },
                },
              },
              [
                _c("div", { staticClass: "table-block-amount" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.commonfunctions.parseFloatOrInt(
                          parseFloat(card.amount)
                        )
                      ) +
                      " €\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: {
                      "large-table-block-label": card.isLarge,
                      "table-block-label": !card.isLarge,
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t(card.labelId)) + "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }